<p-toast />
<p-fileUpload
  #fileUpload
  name="file"
  mode="advanced"
  [showUploadButton]="false"
  [multiple]="multiple$ | async"
  [showCancelButton]="false"
  [accept]="accept"
  [maxFileSize]="25000000"
  [chooseIcon]="defaultIcon.Attach"
  chooseLabel="Attach Files"
  (onSelect)="fileCountChanged($event)"
  (onError)="cd.detectChanges()"
>
  <!--
  (uploadHandler)="fileCountChanged($event)"
  (onBeforeUpload)="fileCountChanged($event)"
  (onRemove)="fileCountChanged($event)"
  -->
  <!-- <ng-template #empty>
  <div>Drag and drop files to here to upload.</div>
</ng-template> -->
  <ng-template #toolbar>
    <div class="flex flex-row grow justify-end">
      <div class="flex flex-col justify-center gap-0">
        <div>Having issues attaching a Pic?</div>
        <div class="p-0 m-0">
          <p-button
            text="true"
            label="Click Here to fix"
            (onClick)="refresh()"
            class="!p-0 !m-0"
            styleClass="!p-0 !m-0"
          />
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #file let-file>
    <div class="flex flex-wrap">
      <div class="flex flex-none vertical-align-middle text-center" style="width: 132px">
        @switch (file.fileType) {
          @case (FileType.PDF) {
            <p-button variant="text" class="file-thumbnail" (click)="launchPDF($event, file)">
              <i class="text-8xl">picture_as_pdf</i>
            </p-button>
          }
          @case (FileType.CSV) {
            <p-button variant="text" class="file-thumbnail">
              <i class="text-8xl">upload_file</i>
            </p-button>
          }
          @case (FileType.XLSX) {
            <p-button variant="text" class="file-thumbnail">
              <i class="text-8xl">upload_file</i>
            </p-button>
          }
          @case (FileType.DOCX) {
            <p-button variant="text" class="file-thumbnail">
              <i class="text-8xl">description</i>
            </p-button>
          }
          @default {
            <p-image
              width="100"
              height="100"
              class="file-thumbnail"
              [src]="getImageUrl(file)"
              alt="Image"
              [preview]="true"
            />
          }
        }
      </div>
      <div class="flex flex-auto">
        <div class="flex flex-col">
          <div class="flex text-center" s-blur="Pii">{{ file.name }}</div>
          <!--[nonFormValue]="file.contentType.toString()"-->
          <div class="flex">
            <s-form-input-enum
              #contentTypeInput
              label="Content"
              [id]="file.name"
              [fieldName]="null"
              [schema]="false"
              [form]="lclFormGroup"
              [required]="true"
              [enumObject]="contentTypeOptions"
              [mapping]="contentTypeMapping"
              [sort]="true"
              (triggerChange)="updateUploadContentType(file, $event)"
            />
          </div>
        </div>
      </div>
      <div class="flex grow">
        <div class="flex grow justify-end align-content-end">
          <!--left margin to sync with existing file icon width-->
          <span style="margin-top: 11px; margin-left: 3px">Pending Save</span>
          <p-button [text]="true" severity="danger" (click)="cancelUpload($event, file)" [icon]="defaultIcon.Cancel" />
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #content let-files="uploadedFiles" let-msgs="messages">
    @if (msgs?.length > 0) {
      <div class="flex flex-col gap-2 mb-2">
        <div class="flex flex-row gap-2 items-center">
          <i class="pi pi-exclamation-triangle text-red-500"></i>
          <span class="text-red-500">There were issues with the file upload:</span>
        </div>
      </div>
    }
    @for (message of msgs; track message) {
      <p-message [severity]="message.severity" [text]="message.text"></p-message>
    }
    @if (newFileRefs$ | async; as newFiles) {
      <div>New Files Pending Save: {{ newFiles?.length }}</div>
      @for (newFile of newFiles; track newFile.path) {
        <ng-container *ngTemplateOutlet="file; context: { $implicit: newFile }"></ng-container>
      }
    }
    <div class="border-1 border-surface-300 border-round">
      <div
        class="flex grow items-center justify-center dropZone border-round-top"
        [class.dropZone]="(fileRefs$ | async)?.length !== 0"
        [class.dropZoneLarge]="(fileRefs$ | async)?.length === 0"
      >
        <span class="vertical-align-bottom">[Drag and Drop Files Here]</span>
      </div>
      @for (file of fileRefsToDisplay$ | async; track file.path) {
        <div class="w-full" style="border-bottom: 1px solid grey; margin-top: 3px">
          <div class="flex flex-wrap">
            <div class="flex flex-none vertical-align-middle text-center" style="width: 132px">
              @switch (file.fileType) {
                @case (FileType.PDF) {
                  <p-button variant="text" class="file-thumbnail" (click)="launchPDF($event, file)">
                    <i class="text-8xl">picture_as_pdf</i>
                  </p-button>
                }
                @case (FileType.XLSX) {
                  <p-button class="file-thumbnail" variant="text">
                    <i class="text-8xl">upload_file</i>
                  </p-button>
                }
                <!-- <ngx-extended-pdf-viewer [src]="this.PDFBlobUrl" *ngSwitchCase="FileType.PDF"
                    [height]="'95%'" [useBrowserLocale]="true" [textLayer]="true" [showHandToolButton]="true">
                  </ngx-extended-pdf-viewer> -->
                @default {
                  @if (file && getBlobPath(file)) {
                    <p-image
                      width="100"
                      height="100"
                      class="file-thumbnail"
                      [src]="getBlobPath(file)"
                      alt="Image"
                      [preview]="true"
                    />
                  } @else {
                    <p-skeleton width="100" height="100" />
                  }
                }
              }
            </div>
            <div class="flex flex-auto">
              <div class="flex flex-col">
                <div class="flex text-center" s-blur="Pii">{{ file.name }}</div>
                <div class="flex">
                  <s-form-input-enum
                    label="Content"
                    [fieldName]="null"
                    [schema]="false"
                    [form]="lclFormGroup"
                    [required]="true"
                    [nonFormValue]="file.contentType.toString()"
                    [enumObject]="contentTypeOptions"
                    [mapping]="contentTypeMapping"
                    [sort]="true"
                    (triggerChange)="updateContentType(file, $event)"
                  />
                </div>
              </div>
            </div>
            <div class="flex grow">
              <div class="flex grow justify-end align-content-end">
                <span style="margin-top: 11px">&nbsp;</span>
                <p-button variant="text" (click)="downloadFile($event, file)" [icon]="defaultIcon.Download" />
                <p-button variant="text" (click)="launchTab($event, file)" [icon]="defaultIcon.Launch" />
                <p-button
                  variant="text"
                  severity="danger"
                  (click)="remove($event, file.path)"
                  [icon]="defaultIcon.Delete"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
</p-fileUpload>
